import { ITicketsDisplayerProps } from "../interfaces/ITicketsDisplayerProps";

export const TicketsDisplayer = ({ Render }: ITicketsDisplayerProps) => {
  return <Render />;
};
